import Result from 'ant-design-pro/lib/Result';
import { Button, Row, Spin } from 'antd';
import gql from 'graphql-tag';
import queryString from 'query-string';
import React from 'react';
import { Query } from 'react-apollo';
import { Redirect, RouteComponentProps } from 'react-router';

import { WechatWorkLogin } from '../../components/WechatWorkLogin';
import { authManager } from '../../services/auth';
import { userManager } from '../../services/user';
import { Authorization } from '../../types/base';

export const OAUTH_QUERY = gql`
  query Auth($code: String!) {
    oauth(code: $code) {
      token
      user {
        id
        name
        mobile
        avatarUrl
        roles {
          id
          name
          permissions {
            id
            action
            resource
            description
          }
        }
      }
    }
  }
`;

interface QueryData {
  oauth: Authorization;
}

interface OAuthParams {
  code?: string;
  state?: string;
  returnPath: string | '/';
}

export const AuthWechatWork = (props: RouteComponentProps) => {
  // 解析query string中的OAuth参数
  const {
    location: { search },
  } = props;
  const oAuthParams = queryString.parse(search) as OAuthParams;

  function redirectToPreviousPage() {
    const returnPathState = props.history.location.state;

    if (returnPathState && returnPathState.returnPath) {
      return returnPathState.returnPath;
    }

    return '/';
  }
  // 有参数，请求OAuth接口
  if (oAuthParams.code) {
    return (
      <Query<QueryData, OAuthParams> query={OAUTH_QUERY} variables={oAuthParams}>
        {({ loading, error, data }) => {
          if (loading) {
            return (
              <Row type="flex" justify="center">
                <Spin size="large" />
              </Row>
            );
          }

          if (error || !data) {
            return (
              <Result
                type="error"
                title="登录失败"
                description="请重试"
                actions={<Button type="primary">重试</Button>}
              />
            );
          }

          authManager.setToken(data.oauth.token);
          userManager.setUser(data.oauth.user);
          return <Redirect to={oAuthParams.returnPath} />;
        }}
      </Query>
    );
  }

  return <WechatWorkLogin redirectPath={props.location.pathname} returnPath={redirectToPreviousPage()} />;
};



// WEBPACK FOOTER //
// ./src/screens/auth/AuthWechatWork.tsx